export type AssignableEmployeeType = 'Guard' | 'Employee' | 'Supervisor';

export const ASSIGNABLE_EMPLOYEE_TYPES: AssignableEmployeeType[] = ['Guard', 'Employee', 'Supervisor'];

const EMPLOYEE_TYPE_LABELS: Record<string, string> = {
  Guard: 'Guard',
  Employee: 'Back Office User',
  Supervisor: 'Supervisor',
  ClientUser: 'Client User',
};

export function employeeTypeLabel(employeeType: string): string {
  return EMPLOYEE_TYPE_LABELS[employeeType] ?? employeeType;
}
